import {ComponentType, lazy} from 'react';
import Login from '../components/security/login.component';
import Signup from "../components/security/signup.component";

// Lazy-loaded components — only downloaded when the route is visited
const Employees = lazy(() => import('../components/employee/employees.component'));
const Projects = lazy(() => import('../components/project/projects.component'));
const Proformas = lazy(() => import('../components/proforma/proformas.component'));
const Settings = lazy(() => import('../components/setup/settings.component'));
const Banks = lazy(() => import('../components/setup/banks.component'));
const Proforma = lazy(() => import("../components/proforma/proforma.component"));
const CurrentUserProformasComponent = lazy(() => import("../components/proforma/current-user-proformas.component"));
const EmployeeComponent = lazy(() => import("../components/employee/employee.component"));
const PendingProformas = lazy(() => import("../components/proforma/pending-proformas.component"));
const Companies = lazy(() => import("../components/setup/companies.component"));
const ChangePassword = lazy(() => import("../components/security/change-password.component"));
const LabourPaymentComponent = lazy(() => import("../components/labour-payment/labour-payment-component"));
const CurrentUserLabourPayments = lazy(() => import("../components/labour-payment/current-user-labour-payments.component"));
const LabourPayments = lazy(() => import("../components/labour-payment/labour-payments.component"));
const PendingLabourPayments = lazy(() => import("../components/labour-payment/pending-labour-payments.component"));
const SignatureSettings = lazy(() => import("../components/setup/signature-settings.component"));
const Profile = lazy(() => import("../components/profile/profile.component"));
const FlowBuilder = lazy(() => import("../components/setup/flow-builder.component"));
const FileTypes = lazy(() => import("../components/setup/file-types.component"));
const MySalaryAdvances = lazy(() => import("../components/salary-advance/my-salary-advances.component"));
const SalaryAdvancesManagement = lazy(() => import("../components/salary-advance/salary-advances.component"));
const WorkflowActions = lazy(() => import("../components/workflow/workflow-actions.component"));
const MyLeaves = lazy(() => import("../components/leave/my-leaves.component"));
const LeavesManagement = lazy(() => import("../components/leave/leaves.component"));
const LeavePolicies = lazy(() => import("../components/leave/leave-policies.component"));
const Holidays = lazy(() => import("../components/leave/holidays.component"));
const MyCommissionClaims = lazy(() => import("../components/commission-claim/my-commission-claims.component"));
const CommissionClaimsManagement = lazy(() => import("../components/commission-claim/commission-claims.component"));
const CommissionPercentages = lazy(() => import("../components/setup/commission-percentages.component"));
const Reports = lazy(() => import("../components/reports/reports.component"));

export interface AppRoute {
    path: string;
    component: ComponentType<any>;
    requiresAuth?: boolean;
    exact?: boolean;
}

export const routes: AppRoute[] = [
    {
        path: '/login',
        component: Login,
        requiresAuth: false,
        exact: true
    },
    {
        path: '/signup',
        component: Signup,
        requiresAuth: false,
        exact: true
    },
    {
        path: '/change-password',
        component: ChangePassword,
        requiresAuth: true,
        exact: true
    },
    {
        path: '/home',
        component: Proforma,
        requiresAuth: true,
        exact: true
    },
    {
        path: '/employees',
        component: Employees,
        requiresAuth: true,
        exact: true
    },
    {
        path: '/employee/:id',
        component: EmployeeComponent,
        requiresAuth: true,
        exact: true
    },
    {
        path: '/projects',
        component: Projects,
        requiresAuth: true,
        exact: true
    },
    {
        path: '/proformas',
        component: Proformas,
        requiresAuth: true,
        exact: true
    },
    {
        path: '/labour-payments',
        component: LabourPayments,
        requiresAuth: true,
        exact: true
    },
    {
        path: '/pending-proformas',
        component: PendingProformas,
        requiresAuth: true,
        exact: true
    },
    {
        path: '/pending-labour-payments',
        component: PendingLabourPayments,
        requiresAuth: true,
        exact: true
    },
    {
        path: '/profile',
        component: Profile,
        requiresAuth: true,
        exact: true
    },
    {
        path: '/settings',
        component: Settings,
        requiresAuth: true,
        exact: true
    },
    {
        path: '/settings/companies',
        component: Companies,
        requiresAuth: true,
        exact: true
    },
    {
        path: '/settings/banks',
        component: Banks,
        requiresAuth: true,
        exact: true
    },
    {
        path: '/settings/file-types',
        component: FileTypes,
        requiresAuth: true,
        exact: true
    },
    {
        path: '/settings/signature',
        component: SignatureSettings,
        requiresAuth: true,
        exact: true
    },
    {
        path: '/',
        component: Proforma,
        requiresAuth: true,
        exact: true
    },
    {
        path: '/proforma',
        component: Proforma,
        requiresAuth: true,
        exact: true
    },
    {
        path: '/proforma/:id',
        component: Proforma,
        requiresAuth: true,
        exact: true
    },
    {
        path: '/labour-payment',
        component: LabourPaymentComponent,
        requiresAuth: true,
        exact: true
    },
    {
        path: '/labour-payment/:id',
        component: LabourPaymentComponent,
        requiresAuth: true,
        exact: true
    },
    {
        path: '/my-proformas',
        component: CurrentUserProformasComponent,
        requiresAuth: true,
        exact: true
    },
    {
        path: '/my-labour-payments',
        component: CurrentUserLabourPayments,
        requiresAuth: true,
        exact: true
    },
    {
        path: '/settings/flow-builder',
        component: FlowBuilder,
        requiresAuth: true,
        exact: true
    },
    {
        path: '/my-salary-advances',
        component: MySalaryAdvances,
        requiresAuth: true,
        exact: true
    },
    {
        path: '/salary-advances',
        component: SalaryAdvancesManagement,
        requiresAuth: true,
        exact: true
    },
    {
        path: '/workflow-actions',
        component: WorkflowActions,
        requiresAuth: true,
        exact: true
    },
    {
        path: '/my-leaves',
        component: MyLeaves,
        requiresAuth: true,
        exact: true
    },
    {
        path: '/leaves',
        component: LeavesManagement,
        requiresAuth: true,
        exact: true
    },
    {
        path: '/settings/leave-policies',
        component: LeavePolicies,
        requiresAuth: true,
        exact: true
    },
    {
        path: '/settings/holidays',
        component: Holidays,
        requiresAuth: true,
        exact: true
    },
    {
        path: '/settings/commission-percentage',
        component: CommissionPercentages,
        requiresAuth: true,
        exact: true
    },
    {
        path: '/my-commission-claims',
        component: MyCommissionClaims,
        requiresAuth: true,
        exact: true
    },
    {
        path: '/commission-claims',
        component: CommissionClaimsManagement,
        requiresAuth: true,
        exact: true
    },
    {
        path: '/reports',
        component: Reports,
        requiresAuth: true,
        exact: true
    },

];
